import { Card } from "react-bootstrap";
import { ErrorBoundary } from '@sentry/react';
import * as Sentry from '@sentry/react';

import styles from './ChartCard.module.css';
import DataSource from "./DataSource.jsx";

function ChartCardError({error}) {
  Sentry.captureException(error);
  return (
    <Card.Body className={styles.ChartCardBody}>
      <h4 className={styles.ChartCardTitle}>This chart failed to load...</h4>
      <p>
         The data might be unavailable or an error occurred. Please try again later.
      </p>
    </Card.Body>
  )
}

function ChartCard({ title, time, children, dataSource }) {
  return (
    <>
      <Card className={styles.ChartCard}>
        <ErrorBoundary
          fallback={ChartCardError}
        >
          <Card.Body className={styles.ChartCardBody}>
            <h4 className={styles.ChartCardTitle}>{title}</h4>
            <div className={styles.ChartArea}>
              {children}
            </div>
          </Card.Body>
          {time && (
            <div className={styles.ChartCardTime}>
              {new Date(time).toLocaleString('en-AU')}
            </div>
          )}
        </ErrorBoundary>
        <DataSource dataSource={dataSource} />
      </Card>
    </>
  )
}

export default ChartCard
